'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _CardStore = require('../../../stores/CardStore');

var _CardStore2 = _interopRequireDefault(_CardStore);

var _Utility = require('../../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _Actions = require('../../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Api = require('../../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _CardList = require('../payment/CardList');

var _CardList2 = _interopRequireDefault(_CardList);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INIT_LOAD_MSG = "Loading saved cards ...";
var NO_CARD_MSG = "You have not saved any cards for transaction.";
var LOAD_ERROR_MSG = "Some error occurred while loading details.";

var PaymentMethodSelect = function (_React$Component) {
    _inherits(PaymentMethodSelect, _React$Component);

    function PaymentMethodSelect(props) {
        _classCallCheck(this, PaymentMethodSelect);

        var _this = _possibleConstructorReturn(this, (PaymentMethodSelect.__proto__ || Object.getPrototypeOf(PaymentMethodSelect)).call(this, props));

        _this.populatePaymentMethods = function (paymentMethods) {
            var self = _this;
            if (Utils.isEmpty(self.state.customerId)) {
                // load the Google/Apple payment methods

                // commented by DA
                // self.setUpGoogleApplePaymentMethods();
                self.setState({ initialMessage: NO_CARD_MSG });
                return;
            }

            if (paymentMethods == null || paymentMethods.length === 0) {
                var userDetailPtrId = _parse2.default.User.current().id;
                var sessionToken = _parse2.default.User.current().getSessionToken();
                var router = _this.props.history;
                var locId = _this.props.locId;
                var currentUser = _parse2.default.User.current();
                var paymentObject = {
                    "customerId": currentUser.get("cus_id")
                };

                _Api2.default.getSavedCards(userDetailPtrId, sessionToken, paymentObject).then(function (res) {
                    if (res.data) {
                        var results = res.data;
                        var defaultPaymentMethodIdx = results.findIndex(function (paymentMethod) {
                            return paymentMethod.default;
                        });

                        var defaultIdx = defaultPaymentMethodIdx == -1 ? '0' : defaultPaymentMethodIdx;

                        var initialMessage = "";
                        if (results.length === 0) {
                            initialMessage = NO_CARD_MSG;
                        }

                        self.setState({
                            paymentMethods: results,
                            selectedPaymentMethod: defaultIdx,
                            initialMessage: initialMessage
                        }, function () {

                            _Actions2.default.addPaymentMethod(self.state.paymentMethods[self.state.selectedPaymentMethod]);
                        });
                    } else {
                        self.setState({ initialMessage: LOAD_ERROR_MSG });
                    }
                }, function (error) {

                    // check the error and alert the invalid session token
                    Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                    self.setState({ initialMessage: NO_CARD_MSG });
                });
            } else {
                // else function never call
                // need to debug if that function used anywhere else
                var defaultPaymentMethodIdx = paymentMethods.findIndex(function (paymentMethod) {
                    return paymentMethod.default;
                });
                var defaultIdx = defaultPaymentMethodIdx == -1 ? '0' : defaultPaymentMethodIdx;

                var initialMessage = "";
                if (paymentMethods.length === 0) {
                    initialMessage = NO_CARD_MSG;
                }

                self.setState({
                    paymentMethods: paymentMethods,
                    selectedPaymentMethod: defaultIdx,
                    initialMessage: initialMessage
                }, function () {
                    _Actions2.default.addPaymentMethod(self.state.paymentMethods[self.state.selectedPaymentMethod]);
                });
            }
        };

        _this.onSelectionChanged = function (e) {

            var selectNo = e.currentTarget.value;

            var selectedPaymentMethod = _this.state.paymentMethods[selectNo];

            _this.setState({
                selectedPaymentMethod: e.currentTarget.value
            }, function () {
                _Actions2.default.addPaymentMethod(_this.state.paymentMethods[_this.state.selectedPaymentMethod]);
            });
        };

        _this.renderAddedCards = function () {
            var self = _this;
            var paymentMethods = _this.state.paymentMethods;

            var component = void 0;

            if (paymentMethods.length === 0) {

                component = _react2.default.createElement(
                    'div',
                    { className: 'ml-4 mt-20 mb-3' },
                    _react2.default.createElement(
                        'h4',
                        { className: "color-red  f16-default" },
                        _this.state.initialMessage
                    )
                );
            } else {

                component = _react2.default.createElement(_CardList2.default, {
                    paymentMethods: paymentMethods,
                    selectedPaymentMethod: _this.state.selectedPaymentMethod,
                    onPaymentSelectionChanged: _this.onSelectionChanged,
                    isAccount: false
                });
            }
            return component;
        };

        _this.getCardListComponent = function () {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'list-group' },
                    _this.renderAddedCards()
                )
            );
        };

        _this.state = {
            customerId: '',
            paymentMethods: [],
            selectedPaymentMethod: -1,
            initialMessage: INIT_LOAD_MSG
            // googleApplePay        : [],
            // showApplePayBtn       : false,
            // showGooglePayBtn      : false
        };
        return _this;
    }

    _createClass(PaymentMethodSelect, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {

            var self = this;
            var currentUser = _parse2.default.User.current();

            if (!Utils.isEmptyObj(currentUser)) {
                self.setState({
                    customerId: currentUser.get("cus_id")
                    // showGooglePayBtn : this.props.showGooglePayBtn,
                    // showApplePayBtn : this.props.showApplePayBtn
                });
            }

            // self.setState({
            //     showGooglePayBtn : this.props.showGooglePayBtn,
            //     showApplePayBtn : this.props.showApplePayBtn
            // });

            // load the Google Apple array
            //commented by DA
            // self.loadGoogleApplePayObj();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            this.getUserAndLoadPaymentMethods();
        }
    }, {
        key: 'getUserAndLoadPaymentMethods',
        value: function getUserAndLoadPaymentMethods() {

            var self = this;

            if (Utils.isEmpty(self.state.customerId)) {
                _parse2.default.User.current().fetch().then(function (user) {
                    self.setState({ customerId: user.get("cus_id") });
                    self.populatePaymentMethods(null);
                }, function (error) {
                    console.log("Error occured while fetching latest user data!" + error);
                });
            } else {
                self.populatePaymentMethods(null);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                this.getCardListComponent()
            );
        }
    }]);

    return PaymentMethodSelect;
}(_react2.default.Component);

exports.default = PaymentMethodSelect;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/PaymentMethodSelect.jsx
// module id = 713
// module chunks = 0